import axiosInstance from "./axios";
import { User, UserUpdateBody } from "./models/user.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchSelf = async (bearerToken: string): Promise<User> => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/Users/self`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user:", error);
    throw error;
  }
};

export const updateSelf = async (
  bearerToken: string,
  payload: UserUpdateBody
): Promise<User> => {
  try {
    const response = await axiosInstance.put(`${apiUrl}/Users/self`, payload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update user:", error);
    throw error;
  }
};
